export default "__VITE_ASSET__63976b51__"